import template from './bLinePlusBarChart.html';
import moment from 'moment';
import d3 from 'd3';

const COLOR_BAR = '#3ABE7C';
const COLOR_LINE = '#386949';

export function bLinePlusBarChartDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: bLinePlusBarChartController,
    controllerAs: 'bLinePlusBarChart',
    bindToController: true,
    scope: {
      tooltipId: "@",
      data: "=",
      canShare: "=",
      currency: "=",
      currencyRatio: "=",
      onShareChart: "&",
      onExportChart: "&"
    }
  };
}

class bLinePlusBarChartController {
  constructor($filter, $scope, $translate, $window, $rootScope) {
    'ngInject';

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$translate = $translate;
    this.$window = $window;
    this.rateTitle = this.$translate.instant('STATS.EFFECTIVE_HOURLY_RATE');
    this.profitabilityTitle = this.$translate.instant('STATS.PROFITABILITY_RATE');
    this.title = `${this.rateTitle} &  ${this.profitabilityTitle}`;
    this.seriesVisibility = {series0: true, series1: true};
    this.$scope.$watch(() => this.data, () => this.updateChart());
    this.$scope.$watch(() => this.currencyRatio, () => this.updateChart());
  }

  // Needed to fix "bar feature" of extreme values being half-way outside of chart or when there is only one value
  addEmptyItems(parsedDataBar, parsedDataLine) {
    if (!parsedDataBar) return; //demo error fix
    if (!parsedDataLine) return; //demo error fix
    parsedDataBar.unshift([
      parsedDataBar[0] && moment(parsedDataBar[0][0]).subtract(1, 'month').valueOf(),
      NaN
    ]);

    parsedDataLine.unshift([
      parsedDataLine[0] && moment(parsedDataLine[0][0]).subtract(1, 'month').valueOf(),
      NaN
    ]);

    parsedDataBar.push([
      parsedDataBar[0] && moment(parsedDataBar[0][parsedDataBar.length - 1]).subtract(1, 'month').valueOf(),
      NaN
    ]);

    parsedDataLine.push([
      parsedDataLine[0] && moment(parsedDataLine[0][parsedDataLine.length - 1]).subtract(1, 'month').valueOf(),
      NaN
    ]);
  }

  drawPointLabels() {
    d3.select('#nv-line-points-labels').remove();
    d3.select('.bLinePlusBarChart .nv-scatter .nv-groups')
      .insert('g', '.nv-groups')
      .attr('id', 'nv-line-points-labels');

    const labelContainer = d3.select('#nv-line-points-labels');
    const points = d3.selectAll('.bLinePlusBarChart .nv-scatter .nv-point');
    points[0].forEach((node, idx) => {
      const translateVal = node.getAttribute('transform')
        .replace('translate', '')
        .replace('(', '')
        .replace(')', '');
      let pos = translateVal.indexOf(',') > -1 ? translateVal.split(',') : translateVal.split(' ');
      pos = pos.map(p => parseFloat(p));
      const value = this.chartOptions.data[1].values[idx][1];

      if (value !== undefined && value !== null && !isNaN(value)) {
        labelContainer.append('text')
          .attr('x', pos[0] - 5)
          .attr('y', pos[1] + 20)
          .attr('class', 'prc-label')
          .text(() => d3.format('0%')(value));
      }
    });
  }

  exportChart() {
    this.$rootScope.exportProfitabilityChart = this.data; //undefined
    this.onExportChart({exportData: {type: 'Profitability'}});
  }

  getRectTooltipPosition(node) {
    const bcr = node.getBoundingClientRect();
    return {top: bcr.top - 38, left: bcr.left - 30};
  }

  getPointTooltipPosition(point) {
    const ctm = point.getScreenCTM();
    return {top: ctm.f - 45, left: ctm.e - 40};
  }

  shareChart() {
    const shareData = {type: 'prof_and_hour_rate'};
    this.onShareChart({shareData});
  }

  updateChart() {
    //if this.data == undefined the chart is not updated
    if (!this.data) {
      return;
    }

    const currency = this.currency;
    const data = this.data;

    this.$rootScope.dataLinePlusBarChart = angular.copy(this.data);
    // TODO: Remove before launch
    // const data = [];
    // let date = moment('2019-11', 'YYYY-MM');
    // for (let i = 10; i > 0; i--) {
    //   date = date.subtract(1, 'month');
    //   const nominator = i % 2 === 0 ? -1 : 1;
    //   data.push({
    //     date: date.format('YYYY-MM'),
    //     effectiveRate: {
    //       costRate: {
    //         currency: "EUR",
    //         rate: Math.random() * 6000 * nominator
    //       },
    //       hourlyRate: {
    //         currency: "EUR",
    //         rate: Math.random() * 6000 * nominator
    //       },
    //       ratio: Math.random() * nominator
    //     }
    //   });
    // }

    const tooltipId = this.tooltipId;
    const parsedDataBar = [];
    const parsedDataLine = [];
    const chartSizeConst = {
      xTickPadding: 28,
      yTickPadding: 30,
      xLabelHeight: 20,
      chartHeight: 375
    };

    data.forEach(item => {
      if (typeof item.effectiveRate.rate !== 'undefined') {
        parsedDataBar.push([
            moment(item.date, 'YYYY-MM').valueOf(),
            item.effectiveRate.rate.hourlyRate.rate * this.currencyRatio
          ]
        );
      } else {
        parsedDataBar.push([
            moment(item.date, 'YYYY-MM').valueOf(),
            0
          ]
        );
      }

      if (typeof item.effectiveRate.rate !== 'undefined') {
        parsedDataLine.push([
            moment(item.date, 'YYYY-MM').valueOf(),
            item.effectiveRate.rate.ratio
          ]
        );
      } else {
        parsedDataLine.push([
            moment(item.date, 'YYYY-MM').valueOf(),
            0
          ]
        );
      }

    });
    this.singlePoint = data.length === 1;
    this.addEmptyItems(parsedDataBar, parsedDataLine);
    angular.element(this.$window).bind('resize', () => {
      setTimeout(() => {
        this.drawPointLabels();
        this.$scope.$digest();
      }, 500);
    });
    this.chartOptions = {
      chart: {
        type: 'linePlusBarChart',
        focusEnable: false,
        noData: this.$translate.instant('NOTHING_TO_SHOW'),
        height: chartSizeConst.chartHeight,
        showLegend: true,
        showControls: false,
        clipEdge: false,
        x: (d, i) => i,
        y: d => d[1],
        margin: {
          left: 140,
          right: 80,
          top: 0,
          bottom: chartSizeConst.xLabelHeight + chartSizeConst.xTickPadding
        },
        callback: () => {
          this.resizing = true;
          setTimeout(() => {
            this.drawPointLabels();
          }, 500);
        },
        tooltip: {
          position: () => {
            const tooltipEl = angular.element(document.getElementById(`view-360-tooltip-${tooltipId}`));
            const parent = tooltipEl.parent();
            if (tooltipEl && parent && !parent.hasClass('view-360-tooltip')) {
              parent.addClass('view-360-tooltip');
            }
            let hoverEl = angular.element(document.getElementsByClassName('hover'));
            if(!hoverEl || !hoverEl.length){
              return {};
            }

            return hoverEl.hasClass('nv-point')
              ? this.getPointTooltipPosition(hoverEl[0])
              : this.getRectTooltipPosition(hoverEl[0]);
          },
          contentGenerator: function (x) {
            const isPoint = !!x.point;
            const monthData = isPoint ? x.point[0] : x.data[0];
            const monthVal = isPoint ? x.point[1] * 100 : x.data[1];
            const month = moment(monthData).format('MMMM').toUpperCase();
            const value = `${d3.format(',.2f')(monthVal)}${isPoint ? '%' : ''}`;
            return `
                <div id="view-360-tooltip-${tooltipId}" class="view-360-tooltip-inner">
                  <div>${month}</div>
                  <div>${value} ${isPoint ? '' : currency}</div>
                </div>`;
          }
        },
        xAxis: {
          tickPadding: chartSizeConst.xTickPadding,
          tickValues: d => d[0].values.map((v, i) => i),
          tickFormat: d => {
            if (parsedDataBar[d] && isNaN(parsedDataBar[d][1])) {
              return '';
            }
            const dx = parsedDataBar[d] && parsedDataBar[d][0] || 0;
            return moment(dx).format('MMM').toUpperCase();
          },
          showMaxMin: false
        },
        y1Axis: {
          tickPadding: chartSizeConst.yTickPadding,
          tickFormat: d => this.currency ? `${d3.format('2r')(d)} ${this.currency}` : `${d3.format('2r')(d)}`,
          showMaxMin: false
        },
        y2Axis: {
          tickPadding: chartSizeConst.yTickPadding,
          tickValues: d => {
            const values = d[1].values.map(v => v[1]).filter(v => !isNaN(v));
            const max = Math.round(Math.max(...values));
            const min = Math.round(Math.min(...values));
            const tickVal = min === max ? Math.abs(max) : Math.abs(max - min) / 5;
            const tickVals = [];
            if (min === 0 && max === 0) {
              return [-100, 0, 100];
            }
            for (let t = min; t <= max; t += tickVal) {
              tickVals.push(t);
            }
            return tickVals;
          },
          tickFormat: d => d3.format('0%')(d),
          showMaxMin: true
        }
      },
      data:
        [
          {
            key: this.rateTitle,
            color: COLOR_BAR,
            bar: true,
            values: parsedDataBar
          },
          {
            key: this.profitabilityTitle,
            color: COLOR_LINE,
            strokeWidth: 4,
            values: parsedDataLine
          }
        ]
    };
  }

  toggleLegend(type) {
    this.seriesVisibility[type] = !this.seriesVisibility[type];
    if (!this.seriesVisibility['series0'] && !this.seriesVisibility['series1']) {
      this.seriesVisibility['series0'] = true;
      this.seriesVisibility['series1'] = true;
    }
    // const nthChild = type === 'series0' ? 1 : 2;
    // const legend = d3.select(`.bLinePlusBarChart .nv-series:nth-child(${nthChild})`).node();
    // legend.dispatchEvent(new MouseEvent('click'));
  }
}
